import * as Handlebars from 'handlebars';
import { SharedConstants } from '@formbird/types';
import { cloneDeep } from 'lodash';
const logger = console;
export class UtilSystemHeader {
    static writeSystemHeaderValue(doc, handlebarsSource) {
        let result;
        if (handlebarsSource && doc) {
            const hbTemplate = Handlebars.compile(handlebarsSource);
            result = hbTemplate(doc);
        }
        return result;
    }
    static writeSystemHeaderSummary(newRecord, template, oldRecord, updates) {
        logger.debug('Writing system header summary');
        if (template) {
            let nameSource;
            let descriptionSource;
            if (template.summaryNameRule || template.summaryDescriptionRule) {
                nameSource = template.summaryNameRule;
                descriptionSource = template.summaryDescriptionRule;
                if (newRecord) {
                    let hbDocument;
                    if (oldRecord) {
                        hbDocument = cloneDeep(oldRecord);
                        // applying updates for Handlebars compiling purpose only
                        const keys = Object.keys(newRecord);
                        for (let i = 0; i < keys.length; i++) {
                            const key = keys[i];
                            hbDocument[key] = newRecord[key];
                        }
                    }
                    else {
                        hbDocument = cloneDeep(newRecord);
                    }
                    let hbTemplate;
                    if (nameSource) {
                        hbTemplate = Handlebars.compile(nameSource);
                        if (updates && updates.systemHeader && updates.systemHeader.summaryName) {
                            newRecord.systemHeader.summaryName = updates.systemHeader.summaryName;
                        }
                        else {
                            newRecord.systemHeader.summaryName = hbTemplate(hbDocument);
                        }
                    }
                    if (descriptionSource) {
                        hbTemplate = Handlebars.compile(descriptionSource);
                        if (updates && updates.systemHeader && updates.systemHeader.summaryDescription) {
                            newRecord.systemHeader.summaryDescription = updates.systemHeader.summaryDescription;
                        }
                        else {
                            newRecord.systemHeader.summaryDescription = hbTemplate(hbDocument);
                        }
                    }
                }
            }
        }
    }
    static writeSystemHeaderCreated(newRecord, operationType, user, now) {
        // Write on insert and update.
        // The created fields represent when and who created this version of the document.
        if (operationType === SharedConstants.INSERT_OPERATION_TYPE
            || operationType === SharedConstants.UPDATE_OPERATION_TYPE) {
            if (!newRecord.systemHeader.createdDate) {
                newRecord.systemHeader.createdDate = (now ? now : new Date());
            }
            if (user) {
                newRecord.systemHeader.createdBy = user.documentId;
            }
        }
        if (operationType === SharedConstants.INSERT_OPERATION_TYPE) {
            if (!newRecord.systemHeader.documentCreatedDate) {
                newRecord.systemHeader.documentCreatedDate = (now ? now : new Date());
            }
            if (user && !newRecord.systemHeader.documentCreatedBy) {
                newRecord.systemHeader.documentCreatedBy = user.documentId;
            }
        }
    }
}
